module.exports = __webpack_public_path__ + "static/media/Concordea.36aae25b.md";